import type { FC } from 'react';
import type { PickProps } from '@/ui/types/types';
import { Flex, Skeleton, Typography } from '@ui';
import { useId } from 'react';
import styles from './DataView.module.css';

type Props = {
    title: string;
    value: string;
} & PickProps<'div', 'ref'>;

type Subcomponents = {
    Skeleton: FC;
};

const DataView: FC<Props> & Subcomponents = ({ title, value, ...props }) => {
    const titleId = useId();
    const valueId = useId();
    return (
        <Flex
            vertical
            align="center"
            aria-labelledby={titleId}
            aria-describedby={valueId}
            className={styles.dataView}
            {...props}
        >
            <Typography.Heading id={valueId} level={4}>{value}</Typography.Heading>
            <Typography.Description id={titleId} level={1}>{title}</Typography.Description>
        </Flex>
    );
};

DataView.Skeleton = () => (
    <Flex vertical justify="center" align="center" gap={6} className={styles.dataView}>
        <Skeleton width={46} height={24} />
        <Skeleton width={26} height={12} />
    </Flex>
);

export { DataView };
